exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!./Styles/sidebar.css"), "");

// module
exports.push([module.id, "", ""]);

// exports
